import { observer } from "mobx-react-lite"

import { Button } from "@/components/Button/Button.tsx"
import { ErrorBoundary } from "@/components/ErrorBoundary/ErrorBoundary.tsx"
import { Horizontal } from "@/components/Flex.ts"
import { SecondaryTextSpan } from "@/components/SecondaryTextSpan/SecondaryTextSpan.ts"
import { Spinner } from "@/components/Spinner/Spinner.tsx"
import { useDevMode } from "@/hooks/useDevMode.ts"
import { Icon20, SlackColor, SuccessFill } from "@/icons/Icons.ts"
import { ellipsize } from "@/styles/textStyles.ts"

import type { SlackNotificationsModel } from "@/routes/auth/SlackNotificationsModel.ts"


export const SlackNotifications = (props: {
  model: SlackNotificationsModel
}) => {
  return (
    <ErrorBoundary renderError={(
      <SecondaryTextSpan>Could not fetch Slack integration status</SecondaryTextSpan>
    )}>
      <SlackNotificationsToggle model={props.model} />
    </ErrorBoundary>
  )
}

const SlackNotificationsToggle = observer((props: {
  model: SlackNotificationsModel
}) => {
  const devMode = useDevMode()
  const model = props.model

  if (model.isLoading.get()) {
    return <Spinner text={ellipsize("Loading")} />
  }

  if (model.isEnabled.get()) {
    return (
      <Horizontal alignItems="center" gap="4px">
        <SuccessFill className={Icon20} color="var(--success-color)" />
        Slack notifications are enabled
        {devMode && (
          <Button kind="alternative" size="small" onClick={model.onResetClick}>
            Reset
          </Button>
        )}
      </Horizontal>
    )
  }

  const authUrl = model.authUrl.get()
  if (!authUrl) return null

  return (
    <a href="#" onClick={model.onEnableNotificationsClick}>
      <Horizontal alignItems="center" gap="8px">
        <SlackColor />
        Enable Slack notifications
      </Horizontal>
    </a>
  )
})

